import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as elasticlunr from "elasticlunr";
import { withPathPrefix } from "../utils";
import * as fetchImport from "unfetch";
elasticlunr && elasticlunr.tokenizer.setSeperator(/[\s\-.\/]+/g);
var fetch = fetchImport.default || fetchImport;
export var SearchIndex = /*#__PURE__*/function () {
  function SearchIndex(a) {
    this._index = elasticlunr.Index.load(a);
  }

  var _proto = SearchIndex.prototype;

  _proto.search = /*#__PURE__*/function () {
    var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a, b) {
      var c, d, _e, _d$_e, _a, _b, f, g, h, e;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (b === void 0) {
                b = 50;
              }

              c = {};
              d = this._index.search(a, {
                expand: !0,
                bool: "AND",
                fields: {
                  content: {
                    boost: 1
                  },
                  title: {
                    boost: 1
                  }
                }
              });

              for (_e = 0; _e < Math.min(b, d.length); _e++) {
                _d$_e = d[_e], _a = _d$_e.ref, _b = _d$_e.score, f = this._index.documentStore.getDoc(_a), g = f.headings[0], h = f.link;
                c[h] ? (f.meta && c[h].meta.push(f.meta), c[h].score = Math.max(c[h].score, _b)) : c[h] = {
                  label: g,
                  link: h,
                  score: _b,
                  meta: f.meta ? [f.meta] : [],
                  content: f.content,
                  httpVerb: f.httpVerb
                };
              }

              e = Object.values(c);
              return _context.abrupt("return", (e.sort(function (c, a) {
                return a.score - c.score;
              }), e));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function search(_x, _x2) {
      return _search.apply(this, arguments);
    }

    return search;
  }();

  return SearchIndex;
}();
export var RemoteSearchIndex = /*#__PURE__*/function () {
  function RemoteSearchIndex(a, b) {
    this.endpoint = a, this.pathPrefix = b;
  }

  var _proto2 = RemoteSearchIndex.prototype;

  _proto2.search = /*#__PURE__*/function () {
    var _search2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(a, b) {
      var c;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (b === void 0) {
                b = 50;
              }

              c = window.location.origin + withPathPrefix(this.endpoint, this.pathPrefix);
              return _context2.abrupt("return", fetch(c + "?q=" + encodeURIComponent(a) + "&l=" + encodeURIComponent(b.toString())).then(function (a) {
                return a.json();
              }).then(function (a) {
                return a.results;
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function search(_x3, _x4) {
      return _search2.apply(this, arguments);
    }

    return search;
  }();

  return RemoteSearchIndex;
}();
export var SearchService = /*#__PURE__*/function () {
  function SearchService() {
    var _this = this;

    this._searchIndex = null, this._indexLoadError = !1, this.search = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(a, b) {
        var c;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (b === void 0) {
                  b = 100;
                }

                if (_this._searchIndex) {
                  _context3.next = 3;
                  break;
                }

                throw new Error("Must initialize search index first");

              case 3:
                _context3.next = 5;
                return _this._searchIndex;

              case 5:
                c = _context3.sent;
                return _context3.abrupt("return", c ? c.search(a, b) : {
                  message: "index load error"
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref.apply(this, arguments);
      };
    }();
  }

  var _proto3 = SearchService.prototype;

  _proto3.init = function init(a, b) {
    if (a === void 0) {
      a = "";
    }

    if (b === void 0) {
      b = "search-index.json";
    }

    a.endsWith("/") && (a = a.substring(0, a.length - 1));
    var c = window.location.origin + withPathPrefix(b, a);
    "undefined" != typeof window && (this._searchIndex = fetch(c + "?i=1").then(function (a) {
      return a.json();
    }).then(function (c) {
      return c && c.__portal_server ? new RemoteSearchIndex(b, a) : new SearchIndex(c);
    }).catch(function () {
      return null;
    }));
  };

  return SearchService;
}();